import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles';


const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const Datatables = ({data, onDetailBooking, showStatus = false  }) => {
    const [search, setSearch] = useState("");

    const formattedData = data.map((booking, index) => ({
      id: index + 1,
      ...booking
    }));

    const filteredData = formattedData.filter((booking) =>
      [booking?.no_invoice, booking?.booking_date, booking?.item_title, booking?.guest_name]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );

    
    const columns = [
      { name: "No", selector: (row) => row.id, width: "70px",style: { display: "flex", justifyContent: "center", alignItems: "center" }, sortable: true },
      { name: "Invoice", selector: (row) => row.no_invoice, sortable: true, minWidth: "100px", maxWidth: "200px", grow:2},
      { name: "Date", selector: (row) => row.booking_date, sortable: true, minWidth: "100px", maxWidth: "600px", grow:3},
      { name: "Title", selector: (row) => row.item_title, sortable: true, minWidth: "100px", maxWidth: "150px" },
      { name: "Guest", selector: (row) => row.guest_name, sortable: true, minWidth: "100px", maxWidth: "200px", grow:2 },
    ];

    if (showStatus) {
      columns.push({
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        minWidth: "120px",
      });
    }

    columns.push({
      name: "Action",
      minWidth: "100px",
      maxWidth: "100px",
      style: { display: "flex", justifyContent: "center", alignItems: "center" },
      cell: (row) => (
        <div>
          <button
            class="btn btn-sm rounded-circle btn-primary me-1"
            onClick={() => onDetailBooking(row)}
          >
            <i class='bx bx-show' style={{ color: "white" }}></i>
          </button>
        </div>
      )
    });

    const customStylesOverride = {
      ...DatatableStyles,
      headCells: {
        ...DatatableStyles.headCells,
        style: {
          ...DatatableStyles.headCells.style,
          fontSize: "14px",
        },
      },
      cells: {
        ...DatatableStyles.cells,
        style: {
          ...DatatableStyles.cells.style,
          fontSize: "12.5px",
        },
      },
    };

  return (
    <div class="col-lg-12 mb-4">
        <div class="d-flex justify-content-start align-items-center mb-2">
                <input
                type="text"
                placeholder="Search..."
                class="form-control w-100"
                style={{ maxWidth: "200px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                />
        </div>

        <div class="datatable-container">
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover={false}
            customStyles={customStylesOverride}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25]}
            paginationComponentOptions={paginationOptions}
            responsive
            />
        </div>
    </div>
  );
};

export default Datatables;
